const IS_DEV = process.env.NODE_ENV === 'development'
const GITLAB_STATUS = process.env.GITLAB_STATUS || null
const IS_PROD =
  GITLAB_STATUS &&
  GITLAB_STATUS === '0' &&
  typeof window !== 'undefined' &&
  window?.document?.location?.host === 'www.test.ru'

/**
 * @function isDevMode - определение режима разработки
 * @description Специальный режим в котором можно видеть дополнительную информацию и тестировать новые функции
 * @returns {boolean} - Режим разработки включается если: работаем локально (IS_DEV) или с параметром ?is_dev=true
 */
export const isDevMode = (): boolean => {
  // Для серверного рендеринга (SSR) или если window не определен
  if (typeof window === 'undefined') {
    return IS_DEV
  }

  // Для клиентского рендеринга
  const urlParams = new URLSearchParams(window.location.search)
  const isDevParam = urlParams.get('is_dev') === 'true'

  return !IS_PROD || isDevParam
}
